import type { FloorPlan } from "~/entities/floor-plan/types";
import axiosInstance from "~/shared/api/axios-instance";
import { TEMP_IMAGE_URL } from "~/shared/ui/EmptyImagePlaceholder";

interface FloorPlanResponse {
  id: number;
  version_id: number;
  name: string;
  img_url: string;
  icon_size: number;
  label_size: number;
  floor_number: number;
}

export const fetchFloorPlans = async (
  branchUid: string,
  versionId?: number,
): Promise<FloorPlan[]> => {
  const { data } = await axiosInstance.get<FloorPlanResponse[]>(
    `branches/${branchUid}/floor-plans/`,
    { params: { version: versionId } },
  );

  return data.map((fp) => ({
    id: fp.id,
    branchVersionId: fp.version_id,
    name: fp.name,
    imageUrl: fp.img_url || TEMP_IMAGE_URL,
    iconSize: fp.icon_size,
    // BE 미배포/롤아웃 중이면 필드가 없을 수 있음 → 기본 배수 1 (기존 렌더와 동일)
    labelSize: fp.label_size ?? 1,
    floorNumber: fp.floor_number,
  }));
};
